import React, { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { Toaster } from "../../components/ui/sonner";
import { initTracker, destroyTracker, trackPageview } from "../../lib/tracker";

const Layout = () => {
  const { pathname, hash } = useLocation();
  const trackerInit = useRef(false);

  useEffect(() => {
    if (!trackerInit.current) {
      initTracker();
      trackerInit.current = true;
    }
    return () => destroyTracker();
  }, []);

  useEffect(() => {
    if (trackerInit.current) trackPageview();
  }, [pathname]);

  useEffect(() => {
    if (hash) {
      // Defer to allow the target section to be mounted
      const id = hash.replace("#", "");
      requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
        }
      });
      return;
    }
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname, hash]);

  return (
    <div className="min-h-screen bg-[#111111] text-white flex flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <Toaster richColors theme="dark" position="bottom-right" />
    </div>
  );
};

export default Layout;
